import React from 'react'
import styles from './styles.css'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import Button from 'orionsoft-parts/lib/components/Button'

export default class Instructions extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.instructions}>
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            <h1>Instrucciones:</h1>
          </div>
          <div className="col-xs-12 col-sm-10" style={{textAlign: 'right', paddingRight: 28}}>
            <MdInfoOutline size={30} />
          </div>
        </div>
        <ol>
          <li>
            Para comenzar, debe ser creado un Template, especificando el documento a firmar y los
            roles de los firmantes. el botón AGREGAR UNA PERSONA permite agregar más roles al
            template. Una vez terminado de especificar los roles, presionar el botón PREPARAR EL
            DOCUMENTO.
          </li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending2.jpeg"
              alt="instruction 1"
            />
          </div>
          <li>
            Dentro del documento, insertar los campos de firmas requeridos, especificando en cada
            campo el rol del firmante. Una vez terminado esto, presionar el botón SIGUIENTE ubicado
            en la parte superior de la pantalla, sobre el documento.
          </li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending3.jpeg"
              alt="instruction 2"
            />
          </div>
          <li>
            Es posible revisar el documento nuevamente para realizarle nuevos cambios. Ésto, y
            presionar el botón CREAR DOCUMENTO, permite crear múltiples versiones del Template, que
            estarán disponibles en la pestaña de Mis Documentos. Para comenzar el envío masivo de
            Templates, debes dirigirte a la pestaña Templates, a la izquierda de la pantalla.
          </li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending4.jpeg"
              alt="instruction 3 "
            />
          </div>
          <li>Seleccionar la opción Envío masivo.</li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending5.jpeg"
              alt="instruction 4"
            />
          </div>
          <li>
            Descargar el documento creado en la página anterior presionando el botón DESCARGAR
            MODELO.
          </li>
          <div className={styles.view}>
            <Button primary>Descargar modelo</Button>
          </div>
          <li>
            El Excel descargado mostrará los roles especificados al crear el Template. Añadir o
            eliminar roles invalidará el documento. Bajo cada rol, es posible añadir múltiples
            correos electrónicos de los firmantes según su rol. Ésto creará un documento por cada
            fila de firmantes. Es posible también añadir columnas de tags adicionales siguiendo el
            formato de la plantilla. Cada columna debe poseer un título "tag".
          </li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending6.jpeg"
              alt="instruction 5"
            />
          </div>
          <li>
            Una vez que el archivo <i>excel</i> se ha terminado, guarda los cambios, y sube el
            documento arrastrando el archivo al recuadro <i>Upload file</i> bajo el campo "Suba el
            archivo con los campos rellenados:", o haciendo <i>click</i> en él.
          </li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending7.jpeg"
              alt="instruction 6"
            />
          </div>
          <li>
            Se mostrarán los roles y los correos electrónicos especificados. Finaliza el proceso
            presionando el botón Enviar Documento.
          </li>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src="/instructionsmassivesending8.jpeg"
              alt="instruction 7"
            />
          </div>
        </ol>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/Main/Instructions/index.js